import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Logo } from './Logo';
const COLUMNS = [{
  title: 'Explorar',
  links: [{
    label: 'Productos',
    href: '#productos'
  }, {
    label: 'Blog',
    href: '#blog'
  }, {
    label: 'Contacto',
    href: '#contacto'
  }]
}, {
  title: 'Legal',
  links: [{
    label: 'Política de privacidad',
    href: '#privacidad'
  }, {
    label: 'Términos',
    href: '#terminos'
  }]
}];
export function Footer() {
  return <footer id="blog" className="relative w-full border-t border-white/[0.06] bg-[#0d0d0f] pb-12 pt-20 sm:pt-24" data-id="element-54" data-mp="38h81hlebwon">
      <div className="mx-auto w-full max-w-content px-6 lg:px-8" data-id="element-55" data-mp="3ldkcr17ga6oj">
        <div className="grid grid-cols-1 gap-14 md:grid-cols-[1.4fr_1fr_1fr]" data-id="element-56" data-mp="3qcxbokblj47h">
          <div data-id="element-57" data-mp="29z6tyark0hfd">
            <Logo size="md" showTagline data-id="element-58" data-mp="29zgnu9fpz8qc" />
            <p className="mt-6 max-w-xs text-[13.5px] font-light leading-relaxed text-white/45" data-id="element-59" data-mp="29xlzel58oyhi">
              Creamos productos digitales que impulsan negocios.
            </p>
            <ul className="mt-7 flex flex-wrap gap-2.5" data-id="element-60" data-mp="3lalgthavm9v0">
              {['Marketing', 'IA', 'Productos Digitales'].map(tag => <li key={tag} className="rounded-full border border-white/[0.08] bg-white/[0.02] px-3 py-1 text-[12px] font-light text-white/55" data-id="element-61" data-mp="3gca5f24xnrao">
                  {tag}
                </li>)}
            </ul>
          </div>

          {COLUMNS.map(column => <nav key={column.title} aria-label={column.title} data-id="element-62" data-mp="33xcvurkbsqx">
              <h2 className="text-[12.5px] font-medium uppercase tracking-[0.16em] text-white/35" data-id="element-63" data-mp="33nmi62lvjkp">
                {column.title}
              </h2>
              <ul className="mt-6 space-y-3.5" data-id="element-64" data-mp="ct765dy57hgm">
                {column.links.map(link => <li key={link.label} data-id="element-65" data-mp="qt04nvfwv1z5">
                    <a href={link.href} className="text-[14px] font-light text-white/55 transition-colors hover:text-white" data-id="element-66" data-mp="qu1fpzwxfogv">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
            </nav>)}
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-white/[0.06] pt-9 sm:flex-row sm:items-center sm:justify-between" data-id="element-67" data-mp="13tkek589qdei">
          <p className="text-[12.5px] font-light text-white/35" data-id="element-68" data-mp="18l2cekezvxv9">
            © {new Date().getFullYear()} Creativo Digital. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center gap-5" data-id="element-69" data-mp="1hjw7u7glai78">
            <span className="text-[12.5px] font-light text-white/35" data-id="element-70" data-mp="1hms4lsgpb0u3">
              @creativodigitalstudio
            </span>
            <a href="https://creativodigital.shop" className="inline-flex items-center gap-1.5 text-[12.5px] font-medium text-white/70 transition-colors hover:text-white" data-id="element-71" data-mp="1rilfl7erum9r">
              creativodigital.shop
              <ArrowUpRightIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-72" data-mp="3tarst1vcjrq2" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}